// Pesos chilenos: sin decimales y con punto de miles ($100.000). El peso no tiene fracciones, así
// que mostrar ",00" en reportes de costos solo agrega ruido a la lectura.
function formatCLP(value: number): string {
    return `$${Math.round(value || 0).toLocaleString('es-CL')}`;
}

export default formatCLP;
